import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnInit,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { DataService } from "../services/data.service";
import { AccessRights } from "../models/interfaces.model";

interface PermissionCheck {
  context: string;
  action: keyof AccessRights,

}
@Directive({
  standalone: true,
  selector: "[appCheckPermission]",
})
export class CheckPermissionDirective implements OnChanges {
  @Input('appCheckPermission')
  permissionObj!: PermissionCheck | PermissionCheck[];
  constructor(

    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private dataService: DataService
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.updateView();
  }
  private updateView(): void {
    let hasPermission = false;


    if (this.dataService.isSuperAdmin) {
      hasPermission = true;
    } else {
      const permissions = Array.isArray(this.permissionObj)
        ? this.permissionObj
        : [this.permissionObj];

      hasPermission = permissions.some((p) =>
        this.dataService.hasPermission(p.context, p.action)
      );
    }


    this.viewContainer.clear();
    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
